




















import { Component, Prop, Mixins } from 'vue-property-decorator';
import FormFieldMixin from '@/mixins/registration/FormFieldMixin';
import RequiredFieldValidator from './validation/RequiredFieldValidator.vue';

@Component(
  {
    components: { RequiredFieldValidator }
  }
)
export default class FormCheckboxToggle extends Mixins(FormFieldMixin) {
  @Prop() readonly value!: boolean;

  $refs!: {
    inputElement: HTMLFormElement;
  };

  public toggleCheckbox (): void {
    this.$refs.inputElement.checked = !this.$refs.inputElement.checked;
    this.$emit('input', this.$refs.inputElement.checked);
  }
}
